import { useExportJob } from '@/features/export/useExportJob';
import { ExportStatusMessage } from '@/features/export/ExportStatusMessage';
import { EXPORT_STATUS, hasExportResult } from '@/features/export/api';
import { toFilterFields, type MetrikaFilterValues } from './api';

const EXPORT_PATH = 'analytics';

/** Create / cancel / download of the analytics users export built from the currently entered filters. */
export const MetrikaUsersExport = ({ filters }: { filters: MetrikaFilterValues }) => {
  const { info, create, cancel, download, isBusy } = useExportJob(EXPORT_PATH, 'export.xlsx');

  return (
    <div style={{ marginBottom: 16 }}>
      <button
        type="button"
        className="btn btn-info"
        disabled={isBusy}
        onClick={() => create.save(toFilterFields(filters))}
      >
        {hasExportResult(info) ? 'Пересоздать экспорт' : 'Создать экспорт'}
      </button>{' '}
      <button
        type="button"
        className="btn btn-danger"
        disabled={isBusy || !info}
        onClick={() => info && cancel.mutate(info.id)}
      >
        Отменить
      </button>{' '}
      {info?.status_id === EXPORT_STATUS.DONE && (
        <button type="button" className="btn btn-success" disabled={isBusy} onClick={() => download.mutate()}>
          Загрузить готовый
        </button>
      )}{' '}
      <ExportStatusMessage statusId={info?.status_id} />
      {info?.progress ? <> {info.progress}</> : null}
      {Object.values(create.errors)
        .flat()
        .map((message) => (
          <p key={message} className="text-red">
            {message}
          </p>
        ))}
      {(cancel.isError || download.isError) && (
        <p className="text-red">Не удалось выполнить действие с экспортом</p>
      )}
    </div>
  );
};
